import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiLoader, TuiIcon, TuiHint } from '@taiga-ui/core';
import { TuiTooltip } from '@taiga-ui/kit';

import { SharedModule } from '../../shared/shared.module';

import { HintComponent } from './hint.component';

@NgModule({
  declarations: [HintComponent],
  imports: [CommonModule, ...TuiHint, TuiLoader, TuiIcon, SharedModule, TuiTooltip],
  exports: [HintComponent],
})
export class HintModule {}
